import { Outlet } from "react-router-dom"

const ShowCaseThemeLayout = () => {
    return (
        <Outlet />
    )
}

export default ShowCaseThemeLayout